<template>
  <div class="mySuggestions">
    <div v-if="$store.state.webNavigator=='pc'">
      <div class="my-advise">
        <div class="content-Tlt2">我的投诉建议</div>
        <div class="content-advise-p margintop20px lineheight15px">请输入您的联系方式，查看历史投诉建议信息</div>
        <!-- 行为验证 -->
                <div class="popupShowAction" id="CaptchaId"></div>
        <div class="margintop15px content-advise-p">
          <span class="red">*</span>
          <span class="marginleft2px">联系手机&nbsp;:</span>
          <input class="content-advise-input marginleft5px" maxlength="11" v-model="phone1"/>
          <span class="red marginleft40px">*</span>
          <span class="marginleft2px">验证码&nbsp;:</span>
          <input class="code-input marginleft5px" maxlength="4" v-model="code"/>
          <el-button
            type="primary"
            class="marginleft5px suggestions-button suggestions-input-minBut"
            @click="getPicCode()"
          >{{timer?(count+'s'):'获取验证码'}}
          </el-button>

          <div id="my-code">
            <el-dialog
              :visible.sync="dialogVisible3"
              :modal="true"
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              :show-close="false"
            >
              <div class="codetitle content-advise-p">提示</div>
              <div class="content-adviseBox">
                  <span class="content-advise-p">
                    <span class="marginleft2px">验证码&nbsp;:</span>
                    <input class="content-advise-input marginleft5px" v-model="code2"/>
                  </span>

                <span style="vertical-align: middle;" v-html="this.picCode" @click="picCodeData()"></span>
              </div>
              <div class="submitcode">
                <el-button @click="close('1')">取 消</el-button>
                <el-button type="primary" @click="phoneCodeData()" class="marginleft9px">确 定</el-button>
              </div>
            </el-dialog>
          </div>
        </div>
        <button class="suggestions-button suggestions-bigBut" @click="seeAdvise()"
                :class="{marginbottom172px:flagTime==false&&flagTime1==false}">查看
        </button>
        <div class="margintop29px my-advise-tips" v-if="flagTime==true">无历史投诉建议信息!</div>
        <el-table
          v-if="flagTime1==true"
          :data="myadvise"
          border
          style="width: 83%"
          class="margintop25px marginbottom70px"
        >
          <el-table-column label="提交时间" width="180">
            <template slot-scope="scope">
              <div>{{!scope.row.contants?"":$myConvertTimeDetails(scope.row.contants[0].createdAt)}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="反馈类型" width="180">
            <template slot-scope="scope">
              <div>{{!scope.row.type?"":scope.row.type}}</div>
            </template>
          </el-table-column>
          <el-table-column label="详细内容">
            <template slot-scope="scope">
              <div>
                <span >{{!scope.row.contants?"":scope.row.contants[0].content}}</span>
                <span v-if="scope.row.contants && scope.row.contants.length >1">

                  &nbsp;
                  (<span class="blue1">补充内容:&nbsp;</span>
                  <span>{{scope.row.contants[1].content?scope.row.contants[1].content:''}})</span>
                  </span>
              </div>

            </template>
          </el-table-column>
          <el-table-column label="反馈回复">
            <template slot-scope="scope">
              <div>
                <span>{{!scope.row.replys?"":scope.row.replys[0].content}}</span>
                <span  v-if="scope.row.replys && scope.row.replys.length > 1">

                &nbsp;
                (<span class="blue1">补充回复:&nbsp;</span>
                <span>{{scope.row.replys[1].content?scope.row.replys[1].content:''}})</span>
                </span>

              </div>

            </template>
          </el-table-column>
          <el-table-column label="回复时间">
            <template slot-scope="scope">
              <div>{{!scope.row.replys?"":$myConvertTimeDetails(scope.row.replys[0].createdAt)}}</div>
            </template>
          </el-table-column>
          <el-table-column label="反馈结果">
            <template slot-scope="scope">
              <div class="red" v-if="!scope.row.replys||scope.row.replys.type==0">未回复</div>
              <div v-else>已回复</div>

            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="blue" @click="addAdvise(scope.row)" v-show="scope.row.contants && scope.row.contants.length <2">补充反馈内容</div>
            </template>
          </el-table-column>
        </el-table>
        <div id="add_advise">
          <el-dialog :visible.sync="dialogVisible1" :show-close="true" :modal="true">
            <div class="add_title">补充反馈内容</div>
            <textarea class="add_content" placeholder="回复如未能解决您的问题，欢迎继续补充内容说明!" v-model="content1" type="text" maxlength="200"></textarea>
            <button class="add-advise-button" type="button" @click="onAddClick()">提交</button>
          </el-dialog>
        </div>

        <div id="suc">
          <el-dialog
            :visible.sync="dialogVisible"
            :show-close="false"
            :modal="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
          >
            <span class="dialog_time">({{totalTime}}S)</span>
          </el-dialog>
        </div>

      </div>
    </div>
    <div v-else>
      <div class="phone-my-advise">
        <div class="phone-title">我的投诉建议</div>

        <div class="phone-p">请输入您的联系方式，查看历史投诉建议信息</div>

        <div class="martop40px marleft137px banner-advise-p1">
          <span class="red1">*</span>
          <span class="marleft14px">联系手机&nbsp;:</span>
          <input class="banner-input marleft14px" type="text" maxlength="11" v-model="phone1"/>
        </div>

        <div class="martop20px marleft161px banner-advise-p1">
          <span class="red1">*</span>
          <span class="marleft14px">验证码&nbsp;:</span>
          <input class="banner-input1 marleft14px" type="text" maxlength="4" v-model="code"/>
          <button class="banner-input1-but" @click="getPicCode()">{{timer?(count+'s'):'获取验证码'}}</button>
        </div>
        <div class="martop61px">
          <!--         @click="changeBanner('1')"-->
          <!--         @click="changeBanner('2')"-->
          <button class="suggestions-button1 suggestions-bigBut" type="button" @click="goBack()">取消</button>
          <button class="suggestions-button2 suggestions-bigBut" type="button" @click="checkPhoneMess()">查看</button>
        </div>
      </div>
      <div class="phone-popup-box">
        <el-dialog
          class="suggestions-popup"
          :visible.sync="dialogVisible3"
          :modal="true"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
        >
          <div class="codetitle content-advise-p">提示</div>
          <div class="content-adviseBox">
              <span class="content-advise-p">
                <span class="font30phone">验证码：&nbsp;</span>
                <input class="content-advise-input marginleft5px" v-model="code2"/>
              </span>
            <span v-html="this.picCode" style="vertical-align: middle;" class="popup-pic" @click="picCodeData()"></span>
          </div>
          <div class="submitcode">
            <button class="suggestions-button-popup displayIB" @click="close('1')">取 消</button>
            <button class="suggestions-button-popup marginleft9px displayIB" type="primary" @click="phoneCodeData()">确 定</button>
          </div>
        </el-dialog>
      </div>

     <div id="suc">
      <el-dialog
            :visible.sync="dialogVisible"
            :show-close="false"
            :modal="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
          >
            <span class="dialog_time">({{totalTime}}S)</span>
      </el-dialog>
      </div>
    </div>

  </div>
</template>

<script>
import {$get, $post, } from '@/others/ajax';
import config from '@/others/interface';

export default {
  name: 'mySuggestions',
  data () {
    return {
      // 新添加用得到的
      flagTime: false,
      flagTime1: false,
      // code3: '', // 图形验证码输入框
      code: '', // 手机验证码输入框
      code2: '', // 图形验证码输入框
      // code1: '', // 手机图形验证码输入框
      dialogVisible: false, // 提交成功倒计时界面
      dialogVisible1: false,
      dialogVisible3: false,
      dialogVisible4: false, // 获取验证码的对话框
      getRandstr: '',
      getTicket: '',
      picCode: '', // 图形验证码
      phone1: '', // 手机号码
      myadvise: [],
      content1: '',
      complaintId: 0,
      totalTime: 3,
      // 新添加用得到的
      timer: null,
      count: 0,
      type: 3,
    };
  },
  methods: {
    // 定义回调函数
    callback (res) {
      // 第一个参数传入回调结果，结果如下：
      // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
      // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
      // CaptchaAppId       String    验证码应用ID。
      // bizState    Any       自定义透传参数。
      // randstr     String    本次验证的随机串，后续票据校验时需传递该参数。
      console.log('callback:', res);
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      // res（请求验证码发生错误，验证码自动返回terror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
      // 此处代码仅为验证结果的展示示例，真实业务接入，建议基于ticket和errorCode情况做不同的业务处理
      if (res.ret === 0) {
        this.getTicket = res.ticket;
        this.getRandstr = res.randstr;
        this.dialogVisible3 = true;
      } else if (res.ret === 2) {
        return this.$message.warning('请重试');
      }
    },
    // 定义验证码js加载错误处理函数
    loadErrorCallback () {
      var appid = '';
      // 生成容灾票据或自行做其它处理
      var ticket = 'terror_1001_' + appid + Math.floor(new Date().getTime() / 1000);
      this.callback({
        ret: 0,
        randstr: '@' + Math.random().toString(36).substr(2),
        ticket,
        errorCode: 1001,
        errorMessage: 'jsload_error',
      });
    },
    countSeconds () {
      if (this.timer) {
        return;
      }
      this.count = 60;
      this.timer = setInterval(() => {
        let a = this.count - 1;
        this.count = a;
        if (a <= 0) {
          clearInterval(this.timer);
          this.timer = null;
          this.count = 60;
        }
      }, 1000);
    },
    onSubmit () {
      this.totalTime = 3;
      this.dialogVisible = true;

      let clock = window.setInterval(() => {
        this.totalTime--;
        if (this.totalTime == 0) {
          window.clearInterval(clock);
          this.dialogVisible = false;
        }
      }, 1000);
    },
    onAddClick () {
      if (this.content1.length <= 15) {
        this.$message.error('至少输入15个字');
      } else {
        this.totalTime = 3;
        this.dialogVisible = true;
        let clock = window.setInterval(() => {
          this.totalTime--;
          if (this.totalTime == 0) {
            window.clearInterval(clock);
            this.dialogVisible = false;
            this.complaintList();
          }
        }, 1000);

        this.dialogVisible1 = false;
        this.addReplyComplaint();
      }
    },
    addAdvise (a) {
      this.complaintId = a.id;
      this.dialogVisible1 = true;
    },
    getPicCode () {
      if (this.phone1 != '') {
        if (this.timer) {
          return;
        }
        this.picCodeData();
        try {
          new TencentCaptcha(document.getElementById('CaptchaId'), '2056848422', this.callback, {
            //   type: 'embed',
          // sdkOpts:{width:140,height:140},
            needFeedBack: false,
          }).show();
        } catch (e) {
          this.loadErrorCallback();
        };
      } else {
        this.$message('请先输入手机号');
      }
    },
    close (type) {
      if (type == '1') {
        this.code2 = '';
        this.dialogVisible3 = !this.dialogVisible3;
      }
    },
    seeAdvise () { // 查看投诉列表
      this.checkPhoneMess();
    },
    addReplyComplaint () {
      $post(config.zmlgw + '/complaint/addReplyComplaint', {
        complaintId: this.complaintId,
        content: this.content1,
        type: 2,
      }).then((resAddReply) => {
        if (resAddReply.code == 200) {
          // this.$message(resAddReply.mes);
          this.content1 = '';
        } else {
          this.$message(resAddReply.mes);
        }
      });
    },
    complaintList () {
      $get(config.zmlgw + '/complaint/complaintList', {
        phone: this.phone1,
        page: 1,
        pagesize: 10,
      }).then((resComplainList) => {
        // this.phone1 = '';
        if (resComplainList.code == 200) {
          this.myadvise = resComplainList.data.rows;
          if (resComplainList.data.count == 0) {
            this.flagTime = true;
            this.flagTime1 = false;
          } else {
            this.flagTime = false;
            this.flagTime1 = true;
          }
        } else {
          this.$message(resComplainList.mes);
        }
      });
    },
    checkPhoneMess () {
      // 检测手机验证码
      $post(config.zmlgw + '/complaint/checkPhoneMess', {
        messageCode: this.code,
        phone: this.phone1,
      }).then((rescheck1) => {
        if (rescheck1.code == 200) {
          this.code = '';
          // this.phone1 = '';
          this.$message(rescheck1.mes);
          if (this.$store.state.webNavigator == 'pc') {
            this.complaintList();
          } else {
            let typeData = {
              type: this.type,
              phone: this.phone1,
            };
            this.$emit('suggestionsList', typeData);
          }
        } else if (rescheck1.code == 202) {
          this.$message('请填写验证码');
        } else {
          this.$message(rescheck1.mes);
        }
      });
    },
    phoneCodeData () {
      // 获取手机验证码
      $post(config.zmlgw + '/complaint/getPhoneMess', {
        sessionId: this.picId,
        height: 50,
        width: 150,
        captcha: this.code2,
        phone: this.phone1,
        randStr: this.getRandstr,
        ticket: this.getTicket,
      }).then((res) => {
        if (res.code == 200) {
          this.close('1');
          this.countSeconds();
          this.$message('手机验证码成功发送');
        } else if (res.code === 202) {
          this.code2 = '';
          this.$message('验证码错误');
          this.picCodeData();
        } else {
          this.code2 = '';
          this.$message(res.mes);
          this.picCodeData();
        }
      });
    },
    picCodeData () {
      // 获取图形验证码
      $get(config.zmlgw + '/complaint/getSetCaptcha', {
        height: 50,
        width: 150,
      }).then((respic) => {
        if (respic.code == 200) {
          this.picCode = respic.data;
          this.picId = respic.sessionId;
        }
      });
    },
    goBack () {
      this.$emit('change', this.type - 2);
    },
  },
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url("mySuggestionsPhone.less");
  }

  @media screen and (min-width: 800px) {
    @import url("mySuggestions.less");
  }
</style>



// WEBPACK FOOTER //
// mySuggestions.vue